import { createContext } from 'react'

const TrainingJourneyContext = createContext()

export default TrainingJourneyContext
